'use strict';

const SoaModel = require('bunsen/models/SoaModel');

const SocialNetwork = module.exports = SoaModel.extend();

Object.assign(SocialNetwork, {
    NAME_PINTEREST: 'PINTEREST'
});

Object.assign(SocialNetwork.prototype, {
    defaults: {
        apiType: "socialNetwork",
        name: null,
        authorizationImpl: "oath2",
        modifiedDate: null
    }
});



// WEBPACK FOOTER //
// ./~/bunsen/models/identity/SocialNetwork.es.js